// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingScreen_root__RHItD"};